// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__Od4eL","alert":"SettungsInbox_alert__OZG17"};